<template>
    <component :is="activeFullPageComponent.componentName"
               v-if="activeFullPageComponent"
               v-bind="activeFullPageComponent.props" />
</template>

<script>
import AccountDetailsView from '@/epos/vue/pages/account-details/AccountDetailsView';
import AccountSearchView from '@/epos/vue/pages/account-search/AccountSearchView';
import DojoReportsView from '@/epos/vue/pages/dojo-reports/DojoReportsView';
import LoginView from '@/vue/pages/login/LoginView';
import MembershipDetailsView from '@/epos/vue/pages/membership-details/MembershipDetailsView';
import OrderSearchView from '@/epos/vue/pages/order-search/OrderSearchView';
import ReportsView from '@/epos/vue/pages/reports/ReportsView';
import TodayView from '@/epos/vue/pages/today/TodayView';
import UiTestView from '@/epos/vue/pages/ui-test/UiTestView';
import { FullPageContainerMixin } from '@/vue/mixins/FullPageContainerMixin';

export default {
    components: {
        AccountDetailsView,
        AccountSearchView,
        DojoReportsView,
        LoginView,
        MembershipDetailsView,
        OrderSearchView,
        ReportsView,
        TodayView,
        UiTestView,
    },

    mixins: [
        FullPageContainerMixin,
    ],

    methods: {
        getFullPageComponentForHash(currentPageHash) {
            // The trailing slash is important here to ensure that we don't match #/accounts which is
            // the account search page.
            if (currentPageHash.indexOf('#/accounts/') === 0) {
                return {
                    componentName: 'AccountDetailsView',
                };
            }

            if (currentPageHash.indexOf('#/memberships/') === 0) {
                return {
                    componentName: 'MembershipDetailsView',
                };
            }

            if (currentPageHash.indexOf('#/reports') === 0) {
                return {
                    componentName: 'ReportsView',
                };
            }

            switch (currentPageHash) {
                case '#/accounts':
                    return {
                        componentName: 'AccountSearchView',
                    };
                case '#/dojo-reports':
                    return {
                        componentName: 'DojoReportsView',
                    };
                case '#/login':
                    return {
                        componentName: 'LoginView',
                    };
                case '#/orders':
                    return {
                        componentName: 'OrderSearchView',
                    };
                case '#/today':
                    return {
                        componentName: 'TodayView',
                    };
                case '#/ui-test':
                    return {
                        componentName: 'UiTestView',
                    };
            }

            return null;
        },
    },
};
</script>
